program Marinaio.Web.Client;

{$R *.dres}

uses
  Vcl.Forms,
  WEBLib.Forms,
  App.Types in 'App.Types.pas',
  App.Config in 'App.Config.pas',
  App.Session in 'App.Session.pas',
  Auth.Service in 'Auth.Service.pas',
  Client.Constants in 'Client.Constants.pas',
  Client.Core in 'Client.Core.pas',
  TerminalForm in 'Templates\TerminalForm.pas',
  Main in 'Main.pas'{*.html},
  Login in 'Frames\Login.pas'{*.html},
  Obvestilo in 'Frames\Obvestilo.pas'{*.html},
  Check in 'Frames\Check.pas'{*.html},
  Foto in 'Frames\Foto.pas'{*.html},
  Pristanisce in 'Frames\Pristanisce.pas'{*.html};

{$R *.res}

procedure DisplayLoginView(AMessage: string = ''); forward;

procedure DisplayMainView;

  procedure ConnectProc;
  begin
    frmMain.ShowLogin;
  end;

begin
  if not modMain.connServer.Connected then
    modMain.connServer.Open(@ConnectProc)
  else
    ConnectProc;
end;

procedure DisplayLoginView(AMessage: string);
begin
  AuthService.Logout;
  modMain.connServer.Connected := False;
  frmMain.ShowLogin;
end;

procedure UnauthorizedAccessProc(AMessage: string);
begin
  DisplayLoginView(AMessage);
end;

procedure StartApplication;
begin
  DisplayMainView;
end;

begin
  Application.Initialize;
  Application.MainFormOnTaskbar := True;
  Application.CreateFormDirect(TmodMain, modMain);
  Application.CreateForm(TfrmMain, frmMain);
  Application.Run;
  modMain.InitApp(@StartApplication, @UnauthorizedAccessProc);
end.
